import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import AskPage from './components/AskPage';
import HallOfFamePage from './components/HallOfFamePage';
export default [new Extend.Routes() //
.add('ask', '/ask', AskPage).add('ask.show', '/ask/:slug', AskPage).add('hallOfFame', '/hall-of-fame', HallOfFamePage), new Extend.Model(User) //
.attribute('gtTitle').attribute('gtSignature').attribute('gtSignatureSource')];